<template>
    <header style="height:150px">
        <template v-if="header_type === 'type4'">
            <!-- <TopBar :loading="loading" :data="data" /> -->
            <LogoBar :loading="loading" :data="data" />
            <HeaderMenuLogin v-if="$route.name === 'Login'" :loading="loading" :data="data" class="d-none d-md-block" />
            <HeaderMenu v-else :loading="loading" :data="data" class="d-none d-md-block" />
        </template>
    </header>
</template>

<script>
    // import TopBar from './type4/TopBar';
    import LogoBar from './type4/LogoBar';
    import HeaderMenu from './type4/HeaderMenu';
    import HeaderMenuLogin from './type4/HeaderMenu_login';

    import { mapGetters } from 'vuex';

    export default {
        data: () => ({
            header_type: '',
            loading: true,
            data: {},
        }),
        components: {
            // TopBar,
            LogoBar,
            HeaderMenu,
            HeaderMenuLogin,
        },
        computed: {
            ...mapGetters('app', ['generalSettings']),
        },
        methods: {
            async getDetails() {
                const res = await this.call_api('get', `setting/header`);
                if (res.status === 200) {
                    this.data = res.data;
                    this.header_type = res.data.header_type;
                    this.loading = false;
                }
            },
        },
        created() {
            this.getDetails();
        },
    };
</script>
<style lang="scss" scoped>
    .header-sticky {
        z-index: 101;
    }
</style>
